/** Приложение запущено как установленное PWA, а не вкладка браузера. */
export default function isPWA(): boolean {
  if (!import.meta.client) {
    return false;
  }

  const { navigator } = globalThis;

  return globalThis.matchMedia('(display-mode: standalone)').matches ||
    globalThis.matchMedia('(display-mode: fullscreen)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
}
